export default __webpack_public_path__ + "static/media/houseNumberShow.56677996.svg";